export interface IValidationPassword {
  lengthValid: boolean
  hasNumber: boolean
  hasSpecialChar: boolean
  isValid: boolean
}

export const usePassword = () => {
  const handlerValidationPassword = (password: string): IValidationPassword => {
    const lengthValid = password.length >= 8
    const hasNumber = /\d/.test(password)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)

    return {
      lengthValid,
      hasNumber,
      hasSpecialChar,
      isValid: lengthValid && hasNumber && hasSpecialChar,
    }
  }

  return { validatePassword: handlerValidationPassword }
}
